import * as React from 'react';
import { Button, Card, CardBody, Split, SplitItem, Switch } from '@patternfly/react-core';
import { ExclamationTriangleIcon} from "@patternfly/react-icons";

interface SendNotificationFieldProps {
    type: "Email" | "Text";
    fieldId: string;
    isChecked: boolean;
    notificationValue: string;
    handleChange: (checked: boolean, event: React.FormEvent<HTMLInputElement>) => void;
    handleEditSettingButton: (value: boolean, type: "Email" | "Text") => void;
    showEditButton: boolean;
}

const SendNotificationField: React.FC<SendNotificationFieldProps> = ({ type, fieldId, isChecked, notificationValue, handleChange, handleEditSettingButton, showEditButton }) => {

    return (
        <Card className="pf-u-mb-md">
            <CardBody>
                <Split hasGutter>
                    <SplitItem isFilled>
                        <div>Send me <strong>{type}</strong> notifications</div>

                        {showEditButton &&
                            <Split hasGutter>
                                <SplitItem>{notificationValue
                                    ?
                                    <span>Sends to {notificationValue}</span>
                                    :
                                    <>
                                        <ExclamationTriangleIcon color="var(--pf-global--warning-color--100)" />
                                        <span className="pf-u-warning-color-200 pf-u-pl-sm">Please add {type === "Email" ? "an email" : "a phone number"}</span>
                                    </>
                                }
                                </SplitItem>
                                <SplitItem>
                                    <Button
                                        variant="link"
                                        onClick={() => handleEditSettingButton(true, type)}
                                        className="pf-u-py-0"
                                    >
                                        Edit
                                    </Button>
                                </SplitItem>
                            </Split>
                        }

                    </SplitItem>
                    <SplitItem>
                        <Switch
                            id={fieldId}
                            aria-label={`Send me ${type} Notifications`}
                            isChecked={isChecked}
                            onChange={handleChange}
                            isDisabled={notificationValue ? false : true}
                        />
                    </SplitItem>
                </Split>
            </CardBody>
        </Card>
    );

};

export default SendNotificationField;